export interface OrderType {
  id: string;
  description: string;
  narrative: string;
  salesOrderType: boolean;
  salesOrderTypeString: string;
  purchaseOrderType: boolean;
  purchaseOrderString: string;
  salesInvoiceType: boolean;
  salesInvoiceString: string;
  purchaseInvoiceType: boolean;
  purchaseInvoiceString: string;
  creditNoteType: boolean;
  creditNoteString: string;
  debitNoteType: boolean;
  debitNoteString: string;
  autoCreatePO: boolean;
  autoCreatePOString: string;
  autoCreatePOFromContract: boolean;
  autoCreatePOFromContractString: string;
  obsolete: boolean;
}
